







import Vue from 'vue';
import DreamForm from '@/vue-components/dreams/DreamForm.vue';
import { DreamWebDAO, WebDream } from '@/web';

export default Vue.extend({
  name: 'DreamAdd',
  components: {
    DreamForm,
  },
  data() {
    return {
      dream: new WebDream('', ''),
    };
  },
  computed: {
    title(): string {
      return 'Sparkello - New Dream';
    },
  },
  methods: {
    async save(dream: WebDream) {
      console.log('Save', dream);
      const savedDream = await DreamWebDAO.getInstance().setDream(dream);
      if (savedDream.id) {
        this.$router.push('/dreams');
      } else {
        console.log('Something went wrong');
      }

    },
    cancel() {
      console.log('Cancel');
      this.$router.back();
    },
  },
});
